import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Box, SubHeadingStyled, DataContainerHeader, ThemeLoader, } from "../../../components/styled/Elements";
import { SettingsWrapper, FormDataContainer,} from "./styled";
import { overviewData } from "../../../helpers/dummyConstants";
import ViewPage from "../../../components/common/pageView/pageView";
import { overviewTileArray } from "../../../helpers/adminConstants/AdminConstants";
import CustomTile from "../../../components/common/statusTiles/CustomTile";
import OverviewApi from "../../../services/api/overviewApi";


const Overview = () => {
    const { t } = useTranslation();
    const [stats, setStats] = useState(overviewTileArray);
    const [overviewDetail, setOverviewDetail] = useState(overviewData);
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        try{
            setLoading(true);
            const response = await OverviewApi.overview();
            if (response?.data) {
                const updatedTileArray = overviewTileArray.map((tile) => {
                    switch (tile.title) {
                        case "TotalBranches": 
                        return { ...tile, count: response?.data?.branch_count };
                        case "TotalHeadquarters": 
                        return { ...tile, count: response?.data?.headquarter_count };
                        case "TotalAdmins": 
                        return { ...tile, count: response?.data?.admins_count };
                        default:
                            return tile;
                    }
                });
                if (response?.data?.admin_director) {
                    const updatedOverviewData = overviewData.map((item) => {
                        const key = item.label; // Match the label with the key in the API response
                        const updatedText = response.data.admin_director[key] || item.text; // Default to existing text if not found
                        return { ...item, text: updatedText };
                    });
                    setOverviewDetail(updatedOverviewData);
                }
                setStats(updatedTileArray);
                
            }
        } catch (error) {
        } finally {
          setLoading(false);
        }
    };
    

    useEffect(() => {
        getData();
    }, []);

    
    return (
        <SettingsWrapper>
            <Box className="content-head">
                <SubHeadingStyled size="16px" color="var(--text)">
					{t("settings")}
				</SubHeadingStyled>
            </Box>
            {loading ? (
                <ThemeLoader />
            ) : (
                <Box className="content-container">
                    <Row className="mt-3">
                        <Col md={12}>
                            
                            <FormDataContainer className="dataContainer">
                                <DataContainerHeader label={t("overview")} />
                                <Box className="content-container">
                                    <Row className="justify-content-center">
                                    {stats.map((tile, key) => (
                                        <Col lg={3} md={6} sm={12} className="my-2" key={key}>
                                            <CustomTile {...tile} className="allBorder" />
                                        </Col>
                                    ))}
                                    </Row>
                                </Box>
                                <Box className="innerFoHead">
                                    <SubHeadingStyled size="16px" color="var(--text)">
                                        {t("AdminDirectorInformation")}
                                    </SubHeadingStyled>
                                </Box>
                                {overviewDetail.map((view, i) => (
                                    <ViewPage
                                        key={view.id}
                                        label={view.label}
                                        text= {view.text}
                                        render={view.render ? view.render : null}
                                    />
                                ))}


                            </FormDataContainer>
                        </Col>
                    </Row>
                </Box>
            )}
        </SettingsWrapper>

    );
};

export default Overview;
